module.exports = __webpack_public_path__ + "img/组 32@2x(1).70e34ec5.png";